module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epigraph"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“Someday")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("after we have mastered the")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("winds and the tides and the waves")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and the gravity")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("we will harness for God")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the energies of love:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and then for the second time")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in the history of the world")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("men will have discovered fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pierre Teilhard de Chardin")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0